import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    panelContent: 'relative w-full',
    searchLocationFieldWrapper: 'l-0 r-0 absolute top-3 z-50 w-full lg:top-8',
    searchLocationField: 'mx-auto max-w-[94%] lg:max-w-[720px]',
    profilePanel:
      'lg:absolute lg:top-10 lg:left-10 lg:z-50 lg:h-[calc(100%-80px)] lg:w-124 lg:bg-white lg:shadow-lg',
    profilePanelContent: 'mb-5 overflow-y-auto lg:mb-0 lg:p-8',
    desktopPopup:
      'absolute top-7 -right-[calc(50%-38px)] z-50 w-[436px] -translate-y-full bg-white p-8 shadow-lg',
    desktopPopupCloseButton:
      'absolute top-2 right-2 flex h-6 w-6 items-center justify-center text-gray-400 hover:text-gray-600',
    noResultsMarker:
      'absolute -top-[244px] -left-[160px] w-fit min-w-80 bg-white px-8 py-12 lg:-left-[500px] lg:min-w-109',
    noResultsTitle: 'heading-xl lg:heading-2xl mb-4',
    noResultsAddress: 'heading-s lg:heading-m text-secondary-hover'
  }
});
